import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../shared';

import { CARD_DASHBOARD_TODAY_ROUTE, CardDashboardTodayComponent } from './';

@NgModule({
    imports: [
        JYoguiSharedModule,
        NgxChartsModule,
        RouterModule.forRoot([CARD_DASHBOARD_TODAY_ROUTE], { useHash: true })
    ],
    declarations: [
        CardDashboardTodayComponent,
    ],
    entryComponents: [
    ],
    providers: [
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiCardDashboardTodayModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/card-dashboard-today/card-dashboard-today.module.ts